var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 49,
    viewBox: "0 0 53 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1017 20.2798L15.5975 17.0468C19.6917 19.0255 22.2843 20.5315 26.882 23.8109C35.5299 14.0015 41.2428 9.02392 51.8605 2.41659L53 5.03567C44.244 12.6765 37.8288 21.1874 28.5957 37.7499C22.9004 31.041 19.0977 26.7657 12.1017 20.2798ZM43.9171 21.5098C44.0651 22.4881 44.1667 23.4819 44.1667 24.4999C44.1667 35.4577 35.2494 44.3749 24.2917 44.3749C13.3339 44.3749 4.41667 35.4577 4.41667 24.4999C4.41667 13.5422 13.3339 4.62492 24.2917 4.62492C28.6443 4.62492 32.6613 6.04709 35.9384 8.42988C37.089 7.44496 38.2616 6.48434 39.4717 5.55242C35.3112 2.21563 30.04 0.208252 24.2917 0.208252C10.876 0.208252 0 11.0843 0 24.4999C0 37.9155 10.876 48.7916 24.2917 48.7916C37.7073 48.7916 48.5833 37.9155 48.5833 24.4999C48.5833 21.8963 48.1637 19.392 47.4041 17.0402C46.2381 18.438 45.0809 19.922 43.9171 21.5098Z",
    fill: "#86D362"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.d0dcaa3b3882a9dfd93dbfaac8e21efd.svg";
export { ForwardRef as ReactComponent };